import React, { useState, useEffect, useCallback } from "react";
import api from "../../../services/api";
import { Swal, Toast } from "../../../services/SwalTemplates";
import { Background, Container, Titulo, Hr, Button, Table, Row, Inputs, Checkbox, BackgroundModal } from "./style";
import { IoPencilOutline, IoTrashOutline } from "react-icons/io5";
import Auth from "../../../services/auth";
import Pagination from "../../../components/Pagination";
import ModalEdit from "../../../components/Modal/Coord/EditLancamentoEventuais";
import { Link } from "react-router-dom";
import { isAuthenticatedDiretor } from "../../../auth";
import { FaCheck } from "react-icons/fa";

export default function EventuaisImportados() {
  const [id] = useState(Auth.id());
  const [page, setPage] = useState(1);
  const [interval, setInterval] = useState(3);
  const [lancamentos_eventuais, setLancamentos_eventuais] = useState([]);
  const [lancamento_eventual, setLancamento_eventual] = useState("");
  const [totalPages, setTotalPages] = useState(0);
  const [search, setSearch] = useState("");
  const [showModalEdit, setShowModalEdit] = useState(false);
  const [showModalSelectCarga, setShowModalSelectCarga] = useState(false);
  const [selecionarEventuais, setSelecionarEventuais] = useState([]);
  const diretor = isAuthenticatedDiretor();
  const [selectedDateRange, setSelectedDateRange] = useState("-1");

  useEffect(() => {
    api
      .get(`/coord/events?idCoord=${id}&searchImports=${true}`)
      .then((response) => {
        setLancamentos_eventuais(response.data.lancamentos_eventuais);
      })
      .catch((error) => {
        Swal.fire({
          title: "Atenção!",
          text: "Não foi possível consultar os dados!",
          icon: "error",
        });
      });
  }, [id, search, showModalEdit, interval]);

  function handleDelete(id, listId) {
    if (listId && listId.length <= 1 && id === null) {
      return Swal.fire({
        title: "Alerta!",
        html: "Selecione <strong>mais de um </strong> lançamento eventual!",
        icon: "warning",
        confirmButtonText: "Ok",
      });
    } else if (listId && listId.length > 1 && id === null) {
      Swal.fire({
        title: "Você tem certeza?",
        html: `
          <div>
            Você não poderá reverter essa ação!<br/><br/>
            Serão excluídos <strong>${listId.length} lançamentos eventuais</strong>!<br/>
          </div>`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        confirmButtonText: "Deletar",
        cancelButtonColor: "gray",
        cancelButtonText: "Cancelar",
      }).then(async (result) => {
        if (result.isConfirmed) {
          // Exibir alerta de loading
          Swal.fire({
            toast: false,
            title: "Aguarde!",
            html: `<div><strong>${listId.length} lançamentos eventuais</strong> estão sendo excluídos!</div>`,
            icon: "info",
            showConfirmButton: false,
            didOpen: () => {
              Swal.showLoading();
            },
          });
          try {
            // Armazena os IDs que falharam e as mensagens de erro
            const failedIds = [];
            const successIds = [];
            // Cria um array de promessas
            const deletePromises = listId.map(async (item) => {
              try {
                const response = await api.delete(`/coord/events/${item.id}`);
                if (response.data.error) {
                  failedIds.push(item.id);
                  return { error: true, id: item.id, message: response.data.error };
                }
                successIds.push(item.id);
                return { error: false, id: item.id };
              } catch (error) {
                failedIds.push(item.id);
                return { error: true, id: item.id, message: error.message };
              }
            });
            // Aguarda todas as promessas serem resolvidas
            await Promise.all(deletePromises);
            Swal.close();
            // Mostra mensagem com base no resultado
            if (failedIds.length > 0) {
              Swal.fire({
                title: "Atenção!",
                html: `
                  <p>${successIds.length} lançamentos foram excluídos com sucesso.</p>
                  <p>${failedIds.length} lançamentos não puderam ser excluídos:</p>
                  <p style="color: red; font-weight: bold">IDs: ${failedIds.join(", ")}</p>
                `,
                icon: "warning",
              });
            } else {
              Toast.fire({
                icon: "success",
                title: `${successIds.length} lançamentos deletados com sucesso!`,
              });
            }
            // Atualiza a lista após a exclusão - remove apenas os que foram excluídos com sucesso
            setLancamentos_eventuais((prevLancamentos) => prevLancamentos.filter((lancamento) => !successIds.includes(lancamento.id)));
            // Atualiza a seleção removendo apenas os itens que foram excluídos com sucesso
            setSelecionarEventuais((prevSelecionar) => prevSelecionar.filter((item) => !successIds.includes(item.id)));
            setSelectedDateRange("-1");
          } catch (error) {
            console.error("Erro ao deletar os lançamentos eventuais:", error);
            Swal.fire("Erro!", "Não foi possível deletar os lançamentos eventuais.", "error");
          }
        }
      });
    } else {
      Swal.fire({
        title: "Você tem certeza?",
        text: "Você não poderá reverter essa ação!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        confirmButtonText: "Deletar",
        cancelButtonColor: "gray",
        cancelButtonText: "Cancelar",
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const response = await api.delete(`/coord/events/${id}`);
            if (response.data.error) {
              return Swal.fire("Exclusão não permitida!", response.data.error, "warning");
            }
            Toast.fire({
              icon: "success",
              title: "Deletado com sucesso!",
            });
            setSelectedDateRange("-1");
            return setLancamentos_eventuais(lancamentos_eventuais.filter((lancamento) => lancamento.id !== id));
          } catch (error) {
            console.error("Erro ao deletar lançamento eventual:", error);
            Swal.fire("Erro!", "Não foi possível deletar o lançamento eventual.", "error");
          }
        }
      });
    }
  }

  const SelecionarUm = useCallback(
    (t) => {
      setSelecionarEventuais(
        (prevState) =>
          prevState.some((selected) => selected.id === t.id && selected.id_carga === t.id_carga)
            ? prevState.filter((selected) => !(selected.id === t.id && selected.id_carga === t.id_carga)) // Remover o item corretamente
            : [...prevState, { id: t.id, id_carga: t.id_carga }] // Adicionar como objeto
      );
    },
    [setSelecionarEventuais]
  );

  const SelectAll = useCallback(() => {
    const cargasUnicas = [...new Set(lancamentos_eventuais.map((t) => t.id_carga))];

    if (cargasUnicas.length === 1) {
      const cargaUnica = cargasUnicas[0];
      const itensFiltrados = lancamentos_eventuais
        .filter((t) => t.id_carga === cargaUnica)
        .map((t) => ({ id: t.id, id_carga: t.id_carga }));
      const todosSelecionados = itensFiltrados.every((item) =>
        selecionarEventuais.some((selected) => selected.id === item.id && selected.id_carga === item.id_carga)
      );
      setSelecionarEventuais(todosSelecionados ? [] : itensFiltrados);
    } else {
      setShowModalSelectCarga(true);
    }
  }, [lancamentos_eventuais, selecionarEventuais]);

  const normalizeString = (str) => {
    if (str === undefined || str === null) {
      return "";
    }
    return str
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase();
  };

  // Filter function that combines both search and date range filters
  const filteredLancamentosEventuais = lancamentos_eventuais.filter((lanc_even) => {
    // Search filter
    const searchNormalized = normalizeString(search);
    const searchMatch =
      !searchNormalized ||
      normalizeString(lanc_even.id?.toString() || "").includes(searchNormalized) ||
      normalizeString(lanc_even.professor || "").includes(searchNormalized) ||
      normalizeString(lanc_even.curso || "").includes(searchNormalized) ||
      normalizeString(lanc_even.centro_custo || "").includes(searchNormalized) ||
      normalizeString(lanc_even.tipo_lancamento || "").includes(searchNormalized) ||
      normalizeString(lanc_even.unidade || "").includes(searchNormalized);

    // Date range filter
    const dateRangeMatch = selectedDateRange === "-1" || `${lanc_even.data_inicio} - ${lanc_even.data_fim}` === selectedDateRange;

    // Both filters must match
    return searchMatch && dateRangeMatch;
  });

  useEffect(() => {
    setPage(totalPages >= 1 ? (totalPages < page ? page - 1 : page) : page);
  }, [page, setPage, totalPages]);

  useEffect(() => {
    setTotalPages(Math.ceil(filteredLancamentosEventuais.length / 15));
  }, [filteredLancamentosEventuais, showModalEdit]);

  return (
    <Background>
      <Container>
        <Titulo>Lançamentos Eventuais Importados</Titulo>
        <Hr />
        <Row>
          <div>
            <Link to={-1}>
              <Button>voltar</Button>
            </Link>
            <Button onClick={() => SelectAll()}>Selecionar Todos</Button>
            <Button onClick={() => handleDelete(null, selecionarEventuais)}>Deletar Selecionados</Button>
            {selecionarEventuais?.length ? (
              <div className="selecionados">
                <strong>Selecionados</strong>
                <div className="cargas">
                  {[...new Set(selecionarEventuais.map((t) => t.id_carga))]
                    .sort((a, b) => a - b)
                    .map((carga, index, array) => {
                      // Filtrar apenas os itens selecionados desta carga específica
                      const itensDaCargaSelecionados = selecionarEventuais.filter((item) => item.id_carga === carga);
                      return (
                        <React.Fragment key={carga}>
                          <p>
                            <strong>Carga {carga}:</strong> {itensDaCargaSelecionados.length}
                          </p>
                          {index < array.length - 1 && "|"}
                        </React.Fragment>
                      );
                    })}
                </div>
              </div>
            ) : null}
          </div>
          <Inputs>
            <select
              value={selectedDateRange}
              onChange={(e) => {
                const dateRangeValue = e.target.value;
                setSelectedDateRange(dateRangeValue);
                setPage(1); // Reset to first page when filter changes
              }}
            >
              <option value="-1">Todas as datas</option>
              {[...new Set(lancamentos_eventuais.map((t) => `${t.data_inicio} - ${t.data_fim}`))]
                .sort((a, b) => {
                  // Sort by start date
                  const dateA = a.split(" - ")[0].split("/").reverse().join("");
                  const dateB = b.split(" - ")[0].split("/").reverse().join("");
                  return dateA.localeCompare(dateB);
                })
                .map((dateRange) => (
                  <option key={dateRange} value={dateRange}>
                    {dateRange}
                  </option>
                ))}
            </select>
            <input
              value={search}
              onChange={(e) => {
                setInterval(e.target.value.length === 0 ? 3 : 300);
                setSearch(e.target.value.toUpperCase());
                setPage(1);
              }}
              type="search"
              placeholder="Pesquisar..."
            />
          </Inputs>
        </Row>
        <Table>
          <table>
            <thead>
              <tr>
                <th hidden={diretor}></th>
                {/* <th hidden={diretor}>Selecionar</th> */}
                <th>
                  ID <br />
                  Planilha
                </th>
                <th>
                  ID <br />
                  Evento
                </th>
                <th>Unidade</th>
                <th>Tipo</th>
                <th>C.C.</th>
                <th>Centro de Custo</th>
                <th>Professor</th>
                <th>Curso</th>
                <th>Data início</th>
                <th>Data fim</th>
                <th>Carga</th>
                <th hidden={diretor}></th>
                <th hidden={diretor}></th>
              </tr>
            </thead>
            <tbody>
              {filteredLancamentosEventuais.slice((page - 1) * 15, page * 15).map((t, i) => {
                const tee = ["TÉCNICO EM", "TECNICO EM", "TECNÓLOGO EM", "TECNOLOGO EM"];
                // Criando uma expressão regular para substituir qualquer um dos itens do array
                const regex = new RegExp(tee.join("|"), "g");
                const centro = t.centro_custo.replace("CURSO", "");
                const auto = t.id_carga;

                return (
                  <tr key={i}>
                    <td hidden={diretor} data-title="ID" onClick={() => SelecionarUm(t)}>
                      <Checkbox title="Selecionar">
                        {selecionarEventuais.some((selected) => selected.id === t.id && selected.id_carga === t.id_carga) && (
                          <FaCheck color="blue" />
                        )}
                      </Checkbox>
                    </td>
                    {auto ? (
                      <td className="id_carga">
                        {/* <RiFileExcel2Fill color="green" title={`${t.id_carga} - Importado`} /> */}
                        {t.id_carga}
                      </td>
                    ) : null}
                    <td
                      data-title="ID"
                      style={{
                        padding: "0 4px",
                      }}
                    >
                      {t.id}
                    </td>
                    <td title={t.unidade} data-title="Unidade" className="td-left">
                      {t.unidade.slice(0, 12)}
                      {t.unidade.length > 12 ? "..." : ""}
                    </td>
                    <td data-title="Tipo" title={t.tipo_lancamento} className="td-left">
                      {t.tipo_lancamento.slice(0, 16)}
                      {t.tipo_lancamento.length > 16 ? "..." : ""}
                    </td>
                    <td data-title="Centro Custo" title={t.centro_custo}>
                      {t.id_centro_custo}
                    </td>
                    <td data-title="Centro Custo" title={t.centro_custo} className="td-left">
                      {centro.slice(0, 16).trim()}
                      {centro.length > 16 ? "..." : ""}
                    </td>
                    <td data-title="Professor" title={t.professor + " | " + t.id_professor} className="td-left">
                      {t.professor.slice(0, 15)}
                      {t.professor.length > 15 ? "..." : ""}
                    </td>
                    <td data-title="Curso" className="td-left" title={t.curso}>
                      {t.curso.replace(regex, "").slice(0, 23).trim()}
                      {t.curso.replace(regex, "").length > 23 ? "..." : ""}
                    </td>
                    <td data-title="Data início">{t.data_inicio}</td>
                    <td data-title="Data fim">{t.data_fim}</td>
                    <td data-title="Carga Horária">{t.carga_horaria ? t.carga_horaria : t.quantidade_deslocamentos}</td>
                    <td hidden={diretor}>
                      <IoPencilOutline
                        title="Editar"
                        style={{
                          fontSize: "25px",
                          cursor: new Date().getMonth() + 1 === parseInt(t.data_inicio.split("/")[1]) ? "pointer" : "unset",
                          color: new Date().getMonth() + 1 === parseInt(t.data_inicio.split("/")[1]) ? "black" : "gray",
                        }}
                        onClick={() => {
                          if (new Date().getMonth() + 1 === parseInt(t.data_inicio.split("/")[1])) {
                            setShowModalEdit(true);
                            setLancamento_eventual(t);
                          }
                        }}
                      />
                    </td>
                    <td hidden={diretor}>
                      <IoTrashOutline
                        title="Excluir"
                        style={{ fontSize: "25px", cursor: "pointer" }}
                        onClick={() => {
                          handleDelete(t.id);
                        }}
                      />
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </Table>
        <ModalEdit showModal={showModalEdit} setShowModal={setShowModalEdit} data={lancamento_eventual} />
        <Pagination page={page} setPage={setPage} totalPages={totalPages} />
        <ModalEscolha
          showModalSelectCarga={showModalSelectCarga}
          setShowModalSelectCarga={setShowModalSelectCarga}
          lancamentos_eventuais={lancamentos_eventuais}
          selecionarEventuais={selecionarEventuais}
          setSelecionarEventuais={setSelecionarEventuais}
        />
      </Container>
    </Background>
  );
}

function ModalEscolha({
  showModalSelectCarga,
  setShowModalSelectCarga,
  lancamentos_eventuais,
  selecionarEventuais,
  setSelecionarEventuais,
}) {
  if (!showModalSelectCarga) return;

  return (
    <BackgroundModal onClick={() => setShowModalSelectCarga(false)}>
      <div
        onClick={(e) => e.stopPropagation()} // Impede o clique de fechar o modal ao clicar dentro dele
        style={{
          border: "2px solid #0093e9",
          background: "white",
          padding: "20px",
          borderRadius: "10px",
        }}
      >
        <h2
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          Selecionar Lançamento Eventual
        </h2>
        <div>
          {[...new Set(lancamentos_eventuais.map((t) => t.id_carga))]
            .sort((a, b) => a - b)
            .map((carga) => {
              // Filtra os itens que possuem a carga selecionada
              const itensFiltrados = lancamentos_eventuais
                .filter((t) => t.id_carga === carga) // Apenas os itens com essa carga
                .map((t) => ({ id: t.id, id_carga: t.id_carga })); // Mantém o formato do objeto

              // Verifica se todos esses itens já estão selecionados
              const todosSelecionados = itensFiltrados.every((item) =>
                selecionarEventuais.some((selected) => selected.id === item.id && selected.id_carga === item.id_carga)
              );
              return (
                <Button
                  key={carga}
                  style={todosSelecionados ? { background: "#38761d" } : {}}
                  onClick={() => {
                    setSelecionarEventuais((prevState) => {
                      if (todosSelecionados) {
                        // Se todos estiverem selecionados, remove apenas os itens deste cargo
                        return prevState.filter(
                          (selected) => !itensFiltrados.some((item) => item.id === selected.id && item.id_carga === selected.id_carga)
                        );
                      } else {
                        // Se nenhum estiver selecionado, adiciona os itens deste cargo, mantendo os de outros cargos
                        // Primeiro, remove quaisquer itens deste cargo que possam estar selecionados parcialmente
                        const filteredPrevState = prevState.filter(
                          (selected) => !itensFiltrados.some((item) => item.id_carga === selected.id_carga)
                        );
                        // Então adiciona todos os itens deste cargo
                        return [...filteredPrevState, ...itensFiltrados];
                      }
                    });
                  }}
                >
                  Carga Planilha: {carga}
                </Button>
              );
            })}
        </div>
      </div>
    </BackgroundModal>
  );
}
